import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { API, formatErr } from "@/context/AuthContext";
import Shell from "@/components/Shell";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { Lock } from "@phosphor-icons/react";

export default function ChangePassword() {
  const nav = useNavigate();
  const [current, setCurrent] = useState("");
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (pw.length < 6) { toast.error("Yeni şifre en az 6 karakter olmalı"); return; }
    if (pw !== pw2) { toast.error("Yeni şifreler eşleşmiyor"); return; }
    setBusy(true);
    try {
      await axios.post(`${API}/auth/change-password`, { current_password: current, new_password: pw });
      toast.success("Şifreniz güncellendi");
      nav("/");
    } catch (err) { toast.error(formatErr(err)); }
    finally { setBusy(false); }
  };

  return (
    <Shell title="Şifre Değiştir" subtitle="Hesap Ayarları">
      <div className="max-w-lg">
        <Card className="p-8 rounded-none sm:rounded-sm border-slate-200 shadow-sm">
          <div className="flex items-center gap-3 mb-6">
            <div className="w-11 h-11 bg-[#1B4776] flex items-center justify-center">
              <Lock size={22} weight="duotone" className="text-white" />
            </div>
            <div>
              <div className="text-lg font-bold text-slate-900 font-heading">Şifrenizi güncelleyin</div>
              <div className="text-xs text-slate-500">Yeni şifre en az 6 karakter olmalıdır.</div>
            </div>
          </div>

          <form onSubmit={submit} className="space-y-5">
            <div>
              <Label className="text-xs uppercase tracking-widest font-bold text-slate-700">Mevcut Şifre</Label>
              <Input type="password" required value={current} data-testid="current-pw"
                     onChange={(e) => setCurrent(e.target.value)}
                     className="mt-2 rounded-none sm:rounded-sm focus-visible:ring-[#1B4776]" />
            </div>
            <div>
              <Label className="text-xs uppercase tracking-widest font-bold text-slate-700">Yeni Şifre</Label>
              <Input type="password" required value={pw} data-testid="new-pw"
                     onChange={(e) => setPw(e.target.value)}
                     className="mt-2 rounded-none sm:rounded-sm focus-visible:ring-[#1B4776]" />
            </div>
            <div>
              <Label className="text-xs uppercase tracking-widest font-bold text-slate-700">Yeni Şifre (Tekrar)</Label>
              <Input type="password" required value={pw2} data-testid="new-pw2"
                     onChange={(e) => setPw2(e.target.value)}
                     className="mt-2 rounded-none sm:rounded-sm focus-visible:ring-[#1B4776]" />
            </div>
            <Button type="submit" data-testid="submit-pw" disabled={busy}
                    className="w-full h-11 rounded-none sm:rounded-sm bg-[#1B4776] hover:bg-[#153859] text-white font-bold tracking-wide">
              {busy ? "Güncelleniyor..." : "Şifreyi Güncelle"}
            </Button>
          </form>
        </Card>
      </div>
    </Shell>
  );
}
